module.exports = __webpack_public_path__ + "d59b162bfa18a3f44ae1b7d8edb9c47f.svg";